import React, { Fragment } from 'react';
import Navbar from '../Navbar/Navbar';
import Hero from '../Hero/Hero';
import Layout from '../UI/Layout/Layout';

const Header = () => {
  return (
    <Fragment>
      <Navbar />
      <Layout>
        <Hero />
      </Layout>
    </Fragment>
  );
};

export default Header;
